<template>
  <v-btn
    :class="{
      'disable-link-styles no-letter-spacing rounded-pill text-transform-none ': true,
      'primary white--text': invert,
      'primary--text text--darken-1': !invert && !disabled,
      'green-gradient-right': gradient && !secondary && !disabled,
      'orange-gradient-right': gradient && secondary && !disabled,
      'secondary white--text': disabled,
      inactive: inactive
    }"
    :disabled="disabled"
    @click="$emit('click')"
    :to="to"
    :width="width"
    :loading="loading"
    :type="type"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    to: { required: false },
    invert: { type: Boolean, default: false },
    width: { type: String, required: false },
    gradient: { type: Boolean, required: false },
    secondary: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    inactive: { type: Boolean, required: false },
    type: { type: String, default: 'button' },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.disable-link-styles::before {
  opacity: 0 !important;
}

.v-btn--disabled {
  &.v-btn--disabled.v-btn--disabled.v-btn--disabled.v-btn--disabled {
    background-color: var(--v-secondary-lighten2) !important;
  }
  &.white--text {
    color: white !important;
  }
}

.inactive {
  pointer-events: none;
}
</style>
